import {Col, Form, Input, Row, Select} from "antd";
import {gutter, Modal, MyForm} from "@/theme";
import {useApi, useApiMutation} from "@/lib/hook";
import {deleteNullValueInObject} from "@/lib/utils";
import {useEffect} from "react";
import {PermissionsSelect, RolePermissionsSelect, RoleSelect} from "@/components";

export const UserEditModal = ({isModalOpen, setIsModalOpen, userId, refetch}) =>{
    const [form] = Form.useForm()
    const initUserForm = (user) =>{
        return {
            first_name: user.first_name,
            last_name: user.last_name,
            roles: user.roles,
            permissions: user.permissions,
            email: user.email,
            is_block_auth: user.is_block_auth ? 1 : 0,
            password: null
        }
    }
    const {data: user, isFetching} = useApi({
        route: {name: 'user.id', query:{id: userId}},
        setting: {
            enabled: Boolean(userId),
            select: (resp) => resp.data
        }
    })
    const update = useApiMutation({
        onSuccess: ()=>{
            refetch()
            setIsModalOpen()
        }
    })

    const onFinish = () =>{
        update.mutate({
            route:{name: 'user.update', query:{id: userId}},
            data: deleteNullValueInObject(form.getFieldsValue())
        })
    }

    useEffect(()=>{
        if (!isFetching && user){
            form.setFieldsValue(initUserForm(user))
        }
    }, [isFetching])

    return(
        <>
            <Modal
                loading={isFetching}
                open={isModalOpen}
                onCancel={setIsModalOpen}
                title={'User details edition'}
                footer={(
                    <>
                        <Modal.Buttons
                            okText={'Update'}
                            cancelText={'Cancel'}
                            onOk={onFinish}
                            onCancel={setIsModalOpen}
                            okProps={{
                                loading: update.isLoading
                            }}
                        />
                    </>
                )}
                width={776}
            >
                <MyForm
                    spinning={update.isLoading}
                    form={form}
                    name="userDetails"
                    autoComplete="off"
                    layout={'vertical'}
                >
                    <MainInfo />
                    <hr
                        className={'mb24'}
                    />
                    <Security />
                    <hr
                        className={'mb24'}
                    />
                    <Permissions />
                </MyForm>
            </Modal>
        </>
    )
}

const MainInfo = () =>{
    return(
        <>
            <Row gutter={gutter}>
                <Col md={12} xs={24}>
                    <Form.Item
                        name='first_name'
                        label='Full name'
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col md={12} xs={24}>
                    <Form.Item
                        name='last_name'
                        label='Last name'
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col md={12} xs={24}>
                    <Form.Item
                        name='email'
                        label='Email'
                    >
                        <Input disabled/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={gutter}>
                <Col md={12} xs={24}>
                    <Form.Item
                        name='is_block_auth'
                        label='Authorization'
                    >
                        <Select
                            options={[
                                {value: 0, label: 'Allowed'},
                                {value: 1, label: 'Disabled'},
                            ]}
                        />
                    </Form.Item>
                </Col>
            </Row>
        </>
    )
}

const Security = () =>{
    return(
        <Row gutter={gutter}>
            <Col md={12} xs={24}>
                <Form.Item
                    name='password'
                    label='Set a new password'
                >
                    <Input.Password />
                </Form.Item>
            </Col>
        </Row>
    )
}

const Permissions = () =>{
    return (
        <>
            <Form.Item
                noStyle
                shouldUpdate
            >
                {({setFieldsValue}) =>(
                    <Form.Item
                        label={'User role'}
                        name={['roles']}
                        wrapperCol={{
                            sm: 24,
                            lg: 12,
                        }}
                    >
                        <RoleSelect
                            allowClear
                            placeholder={'Select user Role'}
                            onChange={(value, options)=>{
                                if (options){
                                    setFieldsValue({
                                        roles: [options.name],
                                        permissions: options.permissions.map((item)=>item.name),
                                        new_permissions: [],
                                    })
                                }else {
                                    setFieldsValue({
                                        role: [],
                                        permissions: [],
                                        new_permissions: [],
                                    })
                                }
                            }}
                        />
                    </Form.Item>
                )}
            </Form.Item>

            <Form.Item
                label={'Role permissions'}
                shouldUpdate
            >
                {({ getFieldValue }) =>(
                    <RolePermissionsSelect
                        placeholder={'Role permissions'}
                        userRoles={getFieldValue('roles')}
                        disabled={true}
                    />
                )}
            </Form.Item>
            <Form.Item
                noStyle
                shouldUpdate
            >
                {({ getFieldValue, setFieldValue }) =>(
                    <Form.Item
                        label={'Add permissions'}
                        name={['new_permissions']}
                    >
                        <PermissionsSelect
                            mode={'multiple'}
                            placeholder={'Add permissions'}
                            userPermissions={getFieldValue('permissions')}
                            userRoles={getFieldValue('roles')}
                            onInitHandler={(value)=>{
                                setFieldValue('new_permissions', value)
                            }}
                        />
                    </Form.Item>
                )}
            </Form.Item>
        </>
    )
}